import { useSelector } from "react-redux";

export function useGetIndividualInclusions(userGroupUniqueName) {
  let userGroupIndividualInclusions = useSelector(
    (rootState) => rootState.userGroup.userGroupDetails[userGroupUniqueName]?.value?.individualInclusionMembers
  );
  userGroupIndividualInclusions = userGroupIndividualInclusions?.map((userGroupIndividualInclusions) => {
    return userGroupIndividualInclusions.userId;
  });
  return userGroupIndividualInclusions;
}
